<mat-card class="widget-card">
    <mat-card-header>
      <mat-card-title>Daily Expenses</mat-card-title>
    </mat-card-header>
    <mat-card-content>
        <div class="chartContainer">
            <canvas baseChart class="chart" [data]="chartData" [options]="chartOptions" [plugins]="chartPlugins" type="bar"></canvas>
        </div>
    </mat-card-content>
  </mat-card>